<!--
 * @Description: 新增流程审批
 * @Autor: lwq
 * @Date: 2020-07-29 09:33:07
 * @LastEditors: yd
 * @LastEditTime: 2020-09-24 11:21:21
 * @FilePath: \mrc-base-server-view\src\views\approver\addApprover.vue
--> 
<template>
  <approverInfo :disabled='disabled' />
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import approverInfo from './modules/approverInfo'
import { addApprover } from '@/service/api/approver'
export default {
  components: { approverInfo },
  props: {},
  data () {
    return {
      disabled: false
    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {

  },
};
</script>

<style scoped>
</style>
